module.exports = __webpack_public_path__ + "img/add_phone.fc6ad1da.svg";